import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import FormTabs from './FormTabs'
import BorrowTab from 'components/BorrowTab'
import DepositTab from 'components/DepositTab'
import WithdrawTab from 'components/WithdrawTab'

import { useAppState } from 'state'
import { FormTab } from 'models'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '45%',
    margin: 'auto',
    border: '1px solid #A5A5A5',
    borderRadius: '4px',
    marginTop: '5rem',
  },
  form: {
    width: '65%',
    margin: 'auto',
    marginTop: '3.5rem',
    marginBottom: '1.5rem',
  },
}))

const renderTab = (tab: FormTab) => {
  switch (tab) {
    case FormTab.BORROW:
      return <BorrowTab />
    case FormTab.DEPOSIT:
      return <DepositTab />
    case FormTab.WITHDRAW:
      return <WithdrawTab />
  }
}

const MainForm = () => {
  const styles = useStyles()
  const { formTab } = useAppState()
  return (
    <Box className={styles.root}>
      <FormTabs />
      <Box className={styles.form}>{renderTab(formTab)}</Box>
    </Box>
  )
}

export default MainForm
